export default __webpack_public_path__ + "0c46c20.png";